module.exports = __webpack_public_path__ + "static/media/bangalore.977f7348.svg";